import {
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO,
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL,
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS,
  GET_ALL_QUOTES,
  GET_ALL_QUOTES_FAIL,
  GET_ALL_QUOTES_SUCCESS,
  GET_BY_ID_QUOTES,
  GET_BY_ID_QUOTES_SUCCESS,
  GET_BY_ID_QUOTES_FAIL,
  DELETE_QUOTES,
  DELETE_QUOTES_SUCCESS,
  DELETE_QUOTES_FAIL,
  QUOTE_STATUS_UPDATE,
  QUOTE_STATUS_UPDATE_SUCCESS,
  QUOTE_STATUS_UPDATE_FAIL,
  DELETE_QUOTES_RESET,
  ADD_AIR_SHIPMENT_INFO,
  ADD_AIR_SHIPMENT_INFO_FAIL,
  ADD_AIR_SHIPMENT_INFO_LOADER,
  ADD_AIR_SHIPMENT_INFO_SUCCESS,
  GET_AIR_SHIPPER_INFO_BY_ID,
  GET_AIR_SHIPPER_INFO_BY_ID_FAIL,
  GET_AIR_SHIPPER_INFO_BY_ID_LOADER,
  GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS,
  ADD_SEA_SHIPMENT_INFO,
  ADD_SEA_SHIPMENT_INFO_SUCCESS,
  ADD_SEA_SHIPMENT_INFO_FAIL,
  ADD_SEA_SHIPMENT_INFO_LOADER,
  GET_SEA_SHIPPER_INFO_BY_ID,
  GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS,
  GET_SEA_SHIPPER_INFO_BY_ID_FAIL,
  GET_SEA_SHIPPER_INFO_BY_ID_LOADER,
  AIR_SHIPPER_INFO_STATUS_UPDATE,
  AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL,
  AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS,
  SEA_SHIPPER_INFO_STATUS_UPDATE,
  SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL,
  SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS
} from "./actionType"

//Add quotes
export const addQuotesSeaExportGeneralCargo = (data, history) => {
  return {
    type: ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO,
    payload: { data, history },
  }
}

export const addQuotesSeaExportGeneralCargoSuccess = data => {
  return {
    type: ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS,
    payload: data,
  }
}
export const addQuotesSeaExportGeneralCargoError = error => {
  return {
    type: ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL,
    payload: error,
  }
}

//Get all quotes
export const getAllQuotes = () => ({
  type: GET_ALL_QUOTES,
})
export const getAllQuotesSuccess = quotes => ({
  type: GET_ALL_QUOTES_SUCCESS,
  payload: quotes,
})
export const getAllQuotesFail = error => ({
  type: GET_ALL_QUOTES_FAIL,
  payload: error,
})

//Get by id quote
export const getByIdQuotes = (id, history) => ({
  type: GET_BY_ID_QUOTES,
  payload: { id, history }
})
export const getByIdQuotesSuccess = quotes => ({
  type: GET_BY_ID_QUOTES_SUCCESS,
  payload: quotes,
})
export const getByIdQuotesFail = error => ({
  type: GET_BY_ID_QUOTES_FAIL,
  payload: error,
})

//Delete quotes
export const deleteQuote = (data) => {
  return {
    type: DELETE_QUOTES,
    payload: { data }
  }
}
export const deleteQuoteSuccess = data => {
  return {
    type: DELETE_QUOTES_SUCCESS,
    payload: data,
  }
}
export const deleteQuoteFail = error => {
  return {
    type: DELETE_QUOTES_FAIL,
    payload: error,
  }
}
export const deleteQuoteReset = () => {
  return {
    type: DELETE_QUOTES_RESET,
    payload: {}
  }
}
//quotes status update
export const quoteStatusUpdate = (data, resetForm, dispatch, getByIdQuotes, id, history) => {
  return {
    type: QUOTE_STATUS_UPDATE,
    payload: { data, resetForm, dispatch, getByIdQuotes, id, history }
  }
}
export const quoteStatusUpdateSuccess = data => {
  return {
    type: QUOTE_STATUS_UPDATE_SUCCESS,
    payload: data,
  }
}
export const quoteStatusUpdateFail = error => {
  return {
    type: QUOTE_STATUS_UPDATE_FAIL,
    payload: error,
  }
}

//add air shipper information
export const addAirShiiperInfo = (data, history) => {
  return {
    type: ADD_AIR_SHIPMENT_INFO,
    payload: { data, history },
  }
}
export const addAirShiiperInfoSuccess = data => {
  return {
    type: ADD_AIR_SHIPMENT_INFO_SUCCESS,
    payload: data,
  }
}
export const addAirShiiperInfoError = error => {
  return {
    type: ADD_AIR_SHIPMENT_INFO_FAIL,
    payload: error,
  }
}
export const addAirShiiperInfoLoader = loader => {
  return {
    type: ADD_AIR_SHIPMENT_INFO_LOADER,
    payload: loader,
  }
}

//get air shipper information by shipper id
export const getAirShipperInfo = (id, history) => ({
  type: GET_AIR_SHIPPER_INFO_BY_ID,
  payload: { id, history }
})
export const getAirShipperInfoSuccess = shipeprInfo => ({
  type: GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS,
  payload: shipeprInfo,
})
export const getAirShipperInfoFail = error => ({
  type: GET_AIR_SHIPPER_INFO_BY_ID_FAIL,
  payload: error,
})
export const getAirShipperInfoLoader = loader => ({
  type: GET_AIR_SHIPPER_INFO_BY_ID_LOADER,
  payload: loader,
})

//add sea shipper information
export const addSeaShipperInfo = (data, history) => {
  return {
    type: ADD_SEA_SHIPMENT_INFO,
    payload: { data, history },
  }
}
export const addSeaShipperInfoSuccess = data => {
  return {
    type: ADD_SEA_SHIPMENT_INFO_SUCCESS,
    payload: data,
  }
}
export const addSeaShipperInfoError = error => {
  return {
    type: ADD_SEA_SHIPMENT_INFO_FAIL,
    payload: error,
  }
}
export const addSeaShipperInfoLoader = loader => {
  return {
    type: ADD_SEA_SHIPMENT_INFO_LOADER,
    payload: loader,
  }
}

//get sea shipper information by shipper id
export const getSeaShipperInfo = (id, history) => ({
  type: GET_SEA_SHIPPER_INFO_BY_ID,
  payload: { id, history }
})
export const getSeaShipperInfoSuccess = shipeprInfo => ({
  type: GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS,
  payload: shipeprInfo,
})
export const getSeaShipperInfoFail = error => ({
  type: GET_SEA_SHIPPER_INFO_BY_ID_FAIL,
  payload: error,
})
export const getSeaShipperInfoLoader = loader => ({
  type: GET_SEA_SHIPPER_INFO_BY_ID_LOADER,
  payload: loader,
})

//air shipper information status update
export const airShipperInfoStatusUpdate = (data, resetForm, dispatch, getAirShipperInfo, shipperId, history) => {
  return {
    type: AIR_SHIPPER_INFO_STATUS_UPDATE,
    payload: { data, resetForm, dispatch, getAirShipperInfo, shipperId, history }
  }
}
export const airShipperInfoStatusUpdateSuccess = data => {
  return {
    type: AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS,
    payload: data,
  }
}
export const airShipperInfoStatusUpdateFail = error => {
  return {
    type: AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL,
    payload: error,
  }
}
export const airShipperInfoStatusUpdateLoader = loader => ({
  type: AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  payload: loader,
})

//sea shipper information status update
export const seaShipperInfoStatusUpdate = (data, resetForm, dispatch, getSeaShipperInfo, shipperId, history) => {
  return {
    type: SEA_SHIPPER_INFO_STATUS_UPDATE,
    payload: { data, resetForm, dispatch, getSeaShipperInfo, shipperId, history }
  }
}
export const seaShipperInfoStatusUpdateSuccess = data => {
  return {
    type: SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS,
    payload: data,
  }
}
export const seaShipperInfoStatusUpdateFail = error => {
  return {
    type: SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL,
    payload: error,
  }
}
export const seaShipperInfoStatusUpdateLoader = loader => ({
  type: SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  payload: loader,
})